import React, { useCallback } from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

interface DateNavigatorProps {
  currentDate: string; // YYYY-MM-DD format
  onDateChange: (newDate: string) => void;
  label?: string;
}

// Helper function to format date to YYYY-MM-DD
const toInputDateString = (date: Date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const DateNavigator: React.FC<DateNavigatorProps> = ({ currentDate, onDateChange, label = 'Дата' }) => {
  const handleDateChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onDateChange(event.target.value);
  }, [onDateChange]);

  const handlePreviousDay = useCallback(() => {
    const date = new Date(currentDate);
    date.setDate(date.getDate() - 1);
    onDateChange(toInputDateString(date));
  }, [currentDate, onDateChange]);

  const handleNextDay = useCallback(() => {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + 1);
    onDateChange(toInputDateString(date));
  }, [currentDate, onDateChange]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <IconButton onClick={handlePreviousDay} size="small">
        <ArrowBackIosIcon fontSize="small" />
      </IconButton>
      <TextField
        label={label}
        type="date"
        value={currentDate}
        onChange={handleDateChange}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ flexGrow: 1 }}
      />
      <IconButton onClick={handleNextDay} size="small">
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
